module.exports = __webpack_public_path__ + "static/2_3_game-tree-4_IT-265785592c18a71fe796d6ed9a086bb1.svg";